import { isBrowser } from '@/utils/env'
import type { NextCookiesStore } from '@/utils/types'
import type { ApolloClient } from '@apollo/client'
import { AppRouterCookiePersister } from '../persister/AppRouterCookiePersister'
import { ClientCookiePersister } from '../persister/ClientCookiePersister'
import { SHOP_SESSION_COOKIE_MAX_AGE, SHOP_SESSION_COOKIE_NAME } from './ShopSession.constants'
import { ShopSessionService } from './ShopSessionService'

export const setupShopSessionServiceClientSide = (apolloClient: ApolloClient<unknown>) => {
  return new ShopSessionService(
    new ClientCookiePersister(SHOP_SESSION_COOKIE_NAME, SHOP_SESSION_COOKIE_MAX_AGE),
    apolloClient,
  )
}

type ServerSideOptions = {
  apolloClient: ApolloClient<unknown>
  cookieStore: NextCookiesStore
}

export const setupShopSessionServiceServerSide = (options: ServerSideOptions) => {
  const { cookieStore, apolloClient } = options
  return new ShopSessionService(
    new AppRouterCookiePersister(cookieStore, SHOP_SESSION_COOKIE_NAME, SHOP_SESSION_COOKIE_MAX_AGE),
    apolloClient,
  )
}

export const getShopSessionIdServer = (cookies: NextCookiesStore) => {
  return cookies.get(SHOP_SESSION_COOKIE_NAME)?.value
}

export const getShopSessionIdClient = () => {
  if (!isBrowser()) {
    throw new Error('Muse be used client-side')
  }
  return new ClientCookiePersister(SHOP_SESSION_COOKIE_NAME, SHOP_SESSION_COOKIE_MAX_AGE).fetch()
}
